import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class ContractPaymentService extends Service {
	constructor(injector: Injector) {
		super("ContractPayment", injector);
	}

	// API
	forContract(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForContract/${id}`);
	}
}